import ErrorIcon from '@mui/icons-material/Error';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import variable from '../shared/style/variable';

interface INotFoundProps {}

const NotFound = (props: INotFoundProps) => {
    const { t } = useTranslation();

    return (
        <Stack direction={'column'} margin={'4rem 0'} alignItems={'center'} spacing={2}>
            <ErrorIcon style={{ height: '5rem', width: '5rem', fill: variable.green }} />
            <Typography variant='h1' style={{ color: variable.green }} gutterBottom>
                {t('pageNotFound')}
            </Typography>
        </Stack>
    );
};

export default NotFound;
